import clsx from 'clsx';
import { useState } from 'react';
import { List } from './Visualizations/List';
import { Bar } from './Visualizations/Bar';
import { Pie } from './Visualizations/Pie';
import { Basic } from './Visualizations/Basic';
import { DynamicHeader } from './DynamicHeader';
import { DynamicFooter } from './DynamicFooter';
import { Card, CardContent } from '../Card';
import { Divider } from '../Divider';
import { Skeleton } from '../Skeleton';

export const DataCard = ({
  title,
  data,
  views,
  columns,
  format,
  orientation,
  refresh,
  bottomLabel,
  leftLabel,
  loading,
  onRefresh,
  enableTimespan = false,
  exportData,
  exportColumns,
  exportTitle,
  theme,
}: DataCardProps) => {
  const [selected, setSelected] = useState(0);
  const [viewType, setViewType] = useState<DashboardCardView>(views[0]);

  const getContent = () => {
    switch (viewType) {
      case 'pie':
        return <Pie data={data} showTotal={true} theme={theme} />;
      case 'graph':
        return (
          <Bar
            data={data}
            bottomLabel={bottomLabel ?? ''}
            leftLabel={leftLabel ?? ''}
            theme={theme}
          />
        );
      case 'basic':
        return (
          <Basic
            data={data}
            format={format}
            orientation={orientation}
            theme={theme}
          />
        );
      default:
        return <List data={data} columns={columns ?? []} />;
    }
  };
  return (
    <Card className="flex flex-col flex-between h-full" fullWidth>
      <DynamicHeader
        title={title}
        views={views}
        setViewType={setViewType}
        selected={selected}
        onSelect={setSelected}
      />
      <Divider />
      <div className="flex flex-grow flex-col overflow-hidden max-w-full">
        {loading ? (
          <Skeleton className="w-full !h-full" />
        ) : (
          <CardContent
            className={clsx('flex flex-grow items-center w-full max-h-full', {
              'justify-start': viewType === 'list',
              'justify-center': viewType !== 'list',
            })}
          >
            {getContent()}
          </CardContent>
        )}
      </div>
      <Divider />
      <DynamicFooter
        exportColumns={exportColumns}
        exportData={exportData}
        exportTitle={exportTitle}
        refresh={refresh}
        onRefresh={onRefresh}
        enableTimespan={enableTimespan}
      />
    </Card>
  );
};
